export default __webpack_public_path__ + "static/media/nexustech.711fc6b0.svg";